module.exports = __webpack_public_path__ + "static/media/red-heart.30776508.svg";